import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  idPrefix: string
}

export const BannerGemsSvg: FC<Props> = ({
  idPrefix,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 87 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <g>
            <g opacity="0.4" filter={`url(#${idPrefix}filter0_f_65596_110178)`}>
              <ellipse
                cx="38.9604"
                cy="54.6901"
                rx="34.2397"
                ry="7.30969"
                fill={`url(#${idPrefix}paint0_linear_65596_110178)`}
              />
            </g>
            <g opacity="0.5" filter={`url(#${idPrefix}filter1_f_65596_110178)`}>
              <path
                d="M63.1956 57.6775C63.1956 58.3861 52.0803 60.8945 37.6658 60.8945C23.2512 60.8945 11.5659 60.32 11.5659 59.6114C-5.93496 57.9302 24.5323 51.0278 38.9468 51.0278C53.3614 51.0278 63.1956 56.9689 63.1956 57.6775Z"
                fill={`url(#${idPrefix}paint1_linear_65596_110178)`}
              />
            </g>
            <g opacity="0.3" filter={`url(#${idPrefix}filter2_f_65596_110178)`}>
              <ellipse
                cx="33.8498"
                cy="58.3755"
                rx="30.8498"
                ry="3.6245"
                fill={`url(#${idPrefix}paint2_linear_65596_110178)`}
              />
            </g>
            <g opacity="0.3" filter={`url(#${idPrefix}filter3_f_65596_110178)`}>
              <ellipse
                cx="35.6178"
                cy="60.6399"
                rx="26.6392"
                ry="1.45628"
                fill={`url(#${idPrefix}paint3_linear_65596_110178)`}
              />
            </g>
          </g>
          <g>
            <path
              d="M37.7897 17.2724C37.9223 17.0428 38.1407 16.8752 38.3969 16.8065L50.6552 13.5219C50.9114 13.4533 51.1844 13.4892 51.414 13.6218L58.322 17.6101C58.5517 17.7427 58.7193 17.9611 58.7879 18.2173L62.0725 30.4756C62.1412 30.7318 62.1052 31.0048 61.9726 31.2345L51.0048 50.2314C50.8722 50.461 50.6537 50.6286 50.3976 50.6973L38.1392 53.9819C37.8831 54.0505 37.6101 54.0146 37.3804 53.882L30.4725 49.8937C30.2428 49.7611 30.0752 49.5427 30.0065 49.2865L26.7219 37.0282C26.6533 36.772 26.6892 36.499 26.8218 36.2693L37.7897 17.2724Z"
              fill="#E96565"
              stroke="#60050F"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M27.6864 36.7698L38.6543 17.7729L43.8842 23.6707L35.409 38.3502L27.6864 36.7698Z"
              fill="#EE8BBB"
            />
            <path
              d="M50.914 14.4878L38.6557 17.7724L43.8856 23.6702L51.8753 20.7995L57.822 18.4761L50.914 14.4878Z"
              fill="#FFC1DF"
            />
            <path
              d="M44.9089 43.834L36.9192 46.7048L30.9725 49.0281L37.8805 53.0164L50.1388 49.7318L61.1066 30.7349L57.822 18.4766L51.8753 20.7999L53.3841 29.1546L44.9089 43.834Z"
              fill="#D74E67"
            />
            <path
              d="M61.1071 30.7351L50.1392 49.732L44.9093 43.8343L53.3845 29.1548L61.1071 30.7351Z"
              fill="#AC2F6B"
            />
            <g>
              <circle
                cx="56.8845"
                cy="34.0554"
                r="0.997079"
                transform="rotate(30 56.8845 34.0554)"
                fill="#BE3778"
              />
              <circle
                cx="53.6878"
                cy="37.1016"
                r="0.747809"
                transform="rotate(30 53.6878 37.1016)"
                fill="#BE3778"
              />
              <circle
                cx="55.8212"
                cy="36.8939"
                r="0.498539"
                transform="rotate(30 55.8212 36.8939)"
                fill="#BE3778"
              />
              <circle
                cx="54.409"
                cy="34.3534"
                r="0.498539"
                transform="rotate(30 54.409 34.3534)"
                fill="#BE3778"
              />
              <circle
                cx="58.8114"
                cy="31.7137"
                r="0.498539"
                transform="rotate(30 58.8114 31.7137)"
                fill="#BE3778"
              />
              <circle
                cx="52.8309"
                cy="42.0756"
                r="0.498539"
                transform="rotate(30 52.8309 42.0756)"
                fill="#BE3778"
              />
              <circle
                cx="54.077"
                cy="39.9164"
                r="0.498539"
                transform="rotate(30 54.077 39.9164)"
                fill="#BE3778"
              />
            </g>
            <path
              d="M43.8864 23.6699L35.4113 38.3493L36.92 46.704L44.898 43.8534L53.3849 29.1538L51.8762 20.7991L43.8864 23.6699Z"
              fill="#FF6480"
            />
            <path
              d="M35.4113 38.3493L43.8864 23.6699L51.8762 20.7991L53.3849 29.1538L35.4113 38.3493Z"
              fill="#FF9BAD"
            />
            <path
              d="M51.124 22.094L44.4963 24.5998L39.2617 33.6665"
              stroke="#FFD5E4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M38.7715 19.5664L29.2992 35.9728"
              stroke="#FFADD4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M40.632 18.3375L50.8473 15.6004"
              stroke="#FFE7F2"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g>
              <circle
                cx="46.2796"
                cy="48.941"
                r="0.747809"
                transform="rotate(30 46.2796 48.941)"
                fill="#B43B51"
              />
              <circle
                cx="39.469"
                cy="50.7662"
                r="0.747809"
                transform="rotate(30 39.469 50.7662)"
                fill="#B43B51"
              />
              <circle
                cx="42.1917"
                cy="50.0357"
                r="0.747809"
                transform="rotate(30 42.1917 50.0357)"
                fill="#B43B51"
              />
              <circle
                cx="40.8719"
                cy="47.8348"
                r="0.498539"
                transform="rotate(30 40.8719 47.8348)"
                fill="#B43B51"
              />
              <circle
                cx="43.8934"
                cy="49.5799"
                r="0.498539"
                transform="rotate(30 43.8934 49.5799)"
                fill="#B43B51"
              />
              <circle
                cx="43.5954"
                cy="47.1042"
                r="0.997079"
                transform="rotate(30 43.5954 47.1042)"
                fill="#B43B51"
              />
            </g>
          </g>
          <g>
            <path
              d="M17.7246 28.5982C17.7246 28.3329 17.83 28.0786 18.0175 27.8911L24.9824 20.9262C25.1699 20.7387 25.4243 20.6333 25.6895 20.6333L31.8805 20.6333C32.1457 20.6333 32.4 20.7387 32.5876 20.9262L39.5524 27.8911C39.74 28.0786 39.8453 28.3329 39.8453 28.5982L39.8453 45.6234C39.8453 45.8886 39.74 46.1429 39.5524 46.3305L32.5876 53.2953C32.4 53.4829 32.1457 53.5882 31.8805 53.5882L25.6895 53.5882C25.4243 53.5882 25.1699 53.4829 24.9824 53.2953L18.0175 46.3305C17.83 46.1429 17.7246 45.8886 17.7246 45.6234L17.7246 28.5982Z"
              fill="#E96565"
              stroke="#60050F"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M18.7246 45.6243L18.7246 28.5991L24.5287 30.5338L24.5287 43.6896L18.7246 45.6243Z"
              fill="#EE8BBB"
            />
            <path
              d="M25.6895 21.6333L18.7246 28.5982L24.5287 30.5329L28.785 25.5027L31.8805 21.6333L25.6895 21.6333Z"
              fill="#FFC1DF"
            />
            <path
              d="M33.0393 43.6887L28.783 48.7189L25.6875 52.5882L31.8785 52.5882L38.8433 45.6234L38.8433 28.5982L31.8785 21.6333L28.783 25.5027L33.0393 30.5328L33.0393 43.6887Z"
              fill="#D74E67"
            />
            <path
              d="M38.8451 28.5991L38.8451 45.6243L33.041 43.6896L33.041 30.5338L38.8451 28.5991Z"
              fill="#AC2F6B"
            />
            <g>
              <circle cx="37.2954" cy="32.4677" r="0.773873" fill="#BE3778" />
              <circle cx="36.3265" cy="35.7557" r="0.580405" fill="#BE3778" />
              <circle cx="37.6838" cy="34.7893" r="0.386937" fill="#BE3778" />
              <circle cx="35.7463" cy="33.6281" r="0.386937" fill="#BE3778" />
              <circle cx="37.6838" cy="30.1457" r="0.386937" fill="#BE3778" />
              <circle cx="37.6838" cy="39.4319" r="0.386937" fill="#BE3778" />
              <circle cx="37.6838" cy="37.4973" r="0.386937" fill="#BE3778" />
            </g>
            <path
              d="M24.5273 30.5336L24.5273 43.6894L28.7836 48.7196L33.0399 43.7076L33.0399 30.5336L28.7836 25.5034L24.5273 30.5336Z"
              fill="#FF6480"
            />
            <path
              d="M24.5273 43.6894L24.5273 30.5336L28.7836 25.5034L33.0399 30.5336L24.5273 43.6894Z"
              fill="#FF9BAD"
            />
            <path
              d="M28.7832 26.6636L25.3008 30.9199V39.0455"
              stroke="#FFD5E4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.4961 29.7588V44.4624"
              stroke="#FFADD4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.2734 28.2113L26.0775 22.4072"
              stroke="#FFE7F2"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g>
              <circle cx="35.9398" cy="46.5907" r="0.580405" fill="#B43B51" />
              <circle cx="32.0706" cy="50.4598" r="0.580405" fill="#B43B51" />
              <circle cx="33.6195" cy="48.9119" r="0.580405" fill="#B43B51" />
              <circle cx="31.8772" cy="47.945" r="0.386937" fill="#B43B51" />
              <circle cx="34.5862" cy="47.945" r="0.386937" fill="#B43B51" />
              <circle cx="33.4243" cy="46.3969" r="0.773873" fill="#B43B51" />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id={idPrefix + 'filter0_f_65596_110178'}
          x="-8.2793"
          y="34.3804"
          width="94.4785"
          height="40.6191"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.5"
            result="effect1_foregroundBlur_65596_110178"
          />
        </filter>
        <filter
          id={idPrefix + 'filter1_f_65596_110178'}
          x="-1.70703"
          y="43.0278"
          width="72.9023"
          height="25.8667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_65596_110178"
          />
        </filter>
        <filter
          id={idPrefix + 'filter2_f_65596_110178'}
          x="1"
          y="52.751"
          width="65.6992"
          height="11.249"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_65596_110178"
          />
        </filter>
        <filter
          id={idPrefix + 'filter3_f_65596_110178'}
          x="6.97852"
          y="57.1836"
          width="57.2793"
          height="6.9126"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_65596_110178"
          />
        </filter>
        <linearGradient
          id={idPrefix + 'paint0_linear_65596_110178'}
          x1="38.9603"
          y1="45.5848"
          x2="38.9604"
          y2="61.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="1" stopColor="#AC7D4B" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint1_linear_65596_110178'}
          x1="38.7904"
          y1="48.967"
          x2="38.6517"
          y2="60.9059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC7D4B" stopOpacity="0.27" />
          <stop offset="0.919275" stopColor="#81674C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint2_linear_65596_110178'}
          x1="62.1346"
          y1="61.9999"
          x2="3.00001"
          y2="61.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#9C4844" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint3_linear_65596_110178'}
          x1="60.0421"
          y1="62.0961"
          x2="8.97852"
          y2="62.0958"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#95813A" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#7D6922" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
